import {getType} from 'mobx-state-tree';
import {padding} from 'polished';
import * as React from 'react';
import {Link} from 'react-router-dom';
import Ellipsis from '../../../components/Ellipsis';
import Flex from '../../../components/Flex';
import ListingPreviewImage from '../../../components/ListingPreviewImage';
import Text from '../../../components/Text';
import userImagePlaceholder from '../../../images/default-avatar.jpg';
import {ChatChannel} from '../../../models/chatChannelModel';
import {
  TextFormat,
  TextFormatType
} from '../../../models/chatChannelModel/message/format';
import {UserModelType} from '../../../models/UsersListModel/UsersListModel';
import {styled} from '../../../utils';

interface ChatItemProps {
  channel: ChatChannel;
  isActive: boolean;
}
// tslint:disable
const ChatItemRoot = styled('li')<{isActive: boolean}>(
  {
    borderBottom: '1px solid #F1F3F6',
    position: 'relative',
    height: 114,
    borderLeft: '2px solid transparent',
    ':hover': {
      background: '#F5F5F5'
    }
  },
  ({isActive, theme}) => {
    if (isActive) {
      return {
        background: '#F5F5F5',
        borderLeftColor: theme.color.secondary
      };
    }
    return {};
  }
);

const ChatItemLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'inherit',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  ...padding(0, 16)
});

export default class UserChatItem extends React.Component<ChatItemProps, {}> {
  private getUser = (users: any) => {
    let usersArr = Array.from(users.values());
    usersArr = usersArr.filter((user: UserModelType, idx) => {
      return user.role && user.role.code !== 'bot';
    });
    return usersArr.length > 0 ? usersArr[0] : null;
  };

  public render() {
    const {
      channel: {id, type, lastMessage, thread, users},
      isActive
    } = this.props;

    const userChat = this.getUser(users);
    let channelName = 'Unknown';
    let previewImageUrl = userImagePlaceholder;

    if (userChat) {
      const user = userChat as UserModelType;
      channelName = `${user.firstName} ${user.lastName || ''}`;
      previewImageUrl = user.avatar;
    }

    return (
      <ChatItemRoot isActive={isActive}>
        <ChatItemLink to={`/ana-messages/${type.toLowerCase()}/${id}`}>
          <div style={{width: '100%'}}>
            <Flex style={{width: '100%'}}>
              <ListingPreviewImage
                src={previewImageUrl}
                badge={thread ? thread!.source : undefined}
                style={{marginRight: 8}}
              />
              <Flex
                direction="column"
                justify="space-between"
                wrap="wrap"
                style={{minWidth: 0}}
              >
                <Text fontSize={16} lineHeight="24px">
                  {channelName}
                </Text>
                <div>
                  {lastMessage &&
                  getType(lastMessage.format) === TextFormat ? (
                    <Ellipsis>
                      <Text color="#888A90" fontSize={12}>
                        {lastMessage.senderName}:{' '}
                        {(lastMessage.format as TextFormatType).text}
                      </Text>
                    </Ellipsis>
                  ) : null}
                  {thread && thread.listing ? (
                    <Ellipsis>
                      <Text fontWeight={700} fontSize={12} withComponent="div">
                        {thread.listing.name}
                      </Text>
                    </Ellipsis>
                  ) : null}
                </div>
              </Flex>
            </Flex>
          </div>
        </ChatItemLink>
      </ChatItemRoot>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatList/private/UserChatItem.tsx